import BreadcrumbCRM from "./BreadcrumbCRM";
import { Form } from "react-bootstrap";
import { Col, Row, Button, InputGroup, Alert } from "react-bootstrap";
import { useState, useEffect } from "react";
import { getClientes, deleteCliente } from "../../services/ClientesService";
import MaoTable from "../common/MaoTable";
import { useNavigate } from "react-router-dom";
import { FaMagnifyingGlassChart, FaClipboardList } from "react-icons/fa6";
import { HiAnnotation } from "react-icons/hi";

export default function ClientesCRM() {
    /*
    Links ->
        https://react-bootstrap.netlify.app/
        https://react-bootstrap.netlify.app/docs/getting-started/introduction/
        https://react-bootstrap.netlify.app/docs/components/breadcrumb
        https://react-bootstrap.netlify.app/docs/forms/overview
        https://react-bootstrap.netlify.app/docs/forms/layout
        https://react-bootstrap.netlify.app/docs/forms/input-group

        https://www.npmjs.com/package/react-icons
     */
    
    const [clientes, setClientes] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        buscar();
    }, [])

    async function buscar() {
        let nombreParam = document.getElementById("txtNombre").value;
        let inactivosParam = document.getElementById("chkIncluirInactivos").checked;
        let resp = await getClientes(nombreParam, inactivosParam);
        if (resp.error) {
            setError(resp.message);
            setClientes([]);
        } else {
            setError("");
            setClientes(resp.data);
        }
    }

    const navigate = useNavigate();

    async function resenia(id) {
        navigate("/crm/clientes/resenia/"+id);
    }

    async function historial(id) {
        navigate("/crm/historial/"+id);
    }

    async function notas(id) {
        navigate("/crm/notas/"+id)
    }

    const columnas = [
        {
            titulo:"Cuit",
            atributo:"cuit"
        },
        {
            titulo:"Nombre / Razón Social",
            atributo:"nombre_razon_social",
            className:"text-truncate max-width-20-em"
        },
        {
            titulo:"Teléfono",
            atributo:"telefono"
        },
        {
            titulo:"Cuidad",
            atributo:"ciudad",
            className:"d-none d-md-table-cell"
        },
        {
            titulo:"Email",
            atributo:"email",
            className:"d-none d-md-table-cell"
        },
        {
            titulo:"Estado",
            atributo:"estado"
        }
    ]

    return <>
        <BreadcrumbCRM active="Clientes - Consulta"/>
        <Form>
            <Row className="align-items-center">
                <Col xs="auto" md="6">
                <InputGroup className="mb-2">
                <Form.Label htmlFor="inlineFormInput" visuallyHidden>
                    Nombre
                </Form.Label>
                <Form.Control
                    id="txtNombre" 
                    placeholder="Nombre a buscar..."
                />
                <Button id="btnBuscar" onClick={buscar}>
                    Buscar
                </Button>
                </InputGroup>
                </Col>
                <Col xs="auto">
                    <Form.Check
                        type="checkbox"
                        id="chkIncluirInactivos"
                        className="mb-2"
                        label="Incluir inactivos"
                        onClick={buscar}
                    />
                </Col>
            </Row>
            {error!==''?
                <Row>
                    <Col xs="auto">
                        <Alert variant="danger" key="danger">{error}</Alert>
                    </Col>
                </Row>:
                <></>
            }
        </Form>
        <MaoTable 
            columnas={columnas} 
            datos={clientes} 
            colId="cliente_id"
            colEstado="estado"
            otrasAcciones={[
                {title:"Reseña", icon:<FaMagnifyingGlassChart />, click: resenia},
                {title:"Historial", icon: <FaClipboardList/>, click: historial},
                {title:"Notas", icon: <HiAnnotation/>, click: notas}
            ]}>
        </MaoTable>
    </>
        
}